import { Component } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { GuestLandingpageComponent } from "./guest-landingpage/guest-landingpage.component";

@Component({
  selector: "app-landing-page",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
  imports: [GuestLandingpageComponent],
})
export class IndexComponent {
  public constructor(private msal: MsalService) {}

  protected login(): void {
    this.msal.loginRedirect();
  }
}
